export default __webpack_public_path__ + "img/apple.c8cd15f09ab7b5e46257705e4a0f48df.svg";